
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject, transient } from "aurelia-framework";
import { ValidationController, ValidationControllerFactory, ValidationRules } from 'aurelia-validation';
import { CustomValidationRenderer } from '@rightship-tech/common-ui/client-validation-system/custom-validation-renderer';
import { RegexConstants } from '@rightship-tech/common-ui/constants/regex.constants';
import { EmailRecipientTypeEnum } from "../../../models/common.models";
import { CorrespondenceEmailModel } from "../../../models/message-centre.models";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { DocumentManagementDialogConstants } from "../../../constants/dialog.constants";
import { DocumentManagementService } from "../../../services/document-management.service";
import {ValidationsClientService} from "@rightship-tech/common-ui/services/basic/validations-client.service";

@autoinject
@transient()
export class DialogShareOutcome {
    public toEmails: CorrespondenceEmailModel[] = [];
    public message: string;
    private _rightshipInspectionId: number;
    private _validator: ValidationController;
    onClose: () => void;
    refreshEmails: (emails: string[]) => void;
    public emails: string[];

    constructor(private dialogClientService: DialogClientService, validationControllerFactory: ValidationControllerFactory, 
        private notificationService: NotificationClientService,
        private documentManagementService: DocumentManagementService,
        private validationsClientService: ValidationsClientService,
    ) { 
        this._validator = validationControllerFactory.createForCurrentScope();
        this._validator.addRenderer(new CustomValidationRenderer());
    }

    async activate(model: { rightshipInspectionId: number, emails: string[], onClose: () => void, refreshEmails: (emails: string[]) => void }) {
        this._rightshipInspectionId = model.rightshipInspectionId;
        this.emails = model.emails;
        this.onClose = model.onClose;
        this.refreshEmails = model.refreshEmails;
        await this.reload();
    }

    async reload() {
        this.toEmails = [{ email: '', emailRecipientTypeId: EmailRecipientTypeEnum.To }];
    }

    getRules(){
        let emailRegex = new RegExp(RegexConstants.Patterns.EmailRfc5322);

        this.toEmails.forEach((email) => {
            ValidationRules
                .ensure('email')
                .required()
                .satisfies(email => {
                    return emailRegex.test(email)
                })
                .withMessage('Email is invalid')
                .on(email);
        });
    }

    getEmailValidationRules() {
        if(this.toEmails.length === 0) {
            this.notificationService.show("Validation error", "Email can not be empty", NotificationType.Error);
            return false;
        }
        return true;
    }

    close() {
        this.dialogClientService.hide();
    }

    addEmail() {
        this.toEmails.push({ email: "", emailRecipientTypeId: EmailRecipientTypeEnum.To });
    }

    manageAccess() {

        //if dialog is opened from Manage Acees then don't need to open that dialog again
        if(this.onClose) {
            this.dialogClientService.hide();
            return;
        }
        this.dialogClientService.show(DocumentManagementDialogConstants.ManageAccesShareOutcomeDialog, { rightshipInspectionId: this._rightshipInspectionId
        , onSave: async () => {await this.reload();}}, true, false, false, "right");
    }

    removeEmail(index: number) {
        this.toEmails.splice(index, 1);
    }

    async share() {
        //Validate email addresses
        this.getRules();
        let validator = await this._validator.validate();
        if(validator.valid && this.getEmailValidationRules()) {

            //Implement the share logic here
            try {
                var result = await this.documentManagementService.shareRightshipInspectionDocumentAccess(this._rightshipInspectionId, this.toEmails.map(x => x.email), false, this.message);
                if(!result.validationResult || !result.validationResult.hasError) {
                    this.notificationService.show("Success", "Access granted successfully", NotificationType.Success);
                    if(this.refreshEmails) this.refreshEmails([...this.toEmails.map(x => x.email), ...this.emails]);
                    if(this.onClose) this.onClose();
                    this.dialogClientService.hide();
                }
                else {
                    this.validationsClientService.showValidationErrors(result.validationResult);
                }
            } 
            catch (error) {
                this.notificationService.show("Error", "Error when sharing access", NotificationType.Error);
            }
            
        }
    }
}